<template>
  <b-modal :id="id" @close="clean" @hidden="clean" @ok="confirm" title="Создать агента" ok-title="Создать" header-bg-variant="dark" header-text-variant="light" ok-variant="dark">
    <b-form ref="agent_form">
      <b-form-group description="Название агента" :invalid-feedback="invalidName">
        <b-form-input v-model="name" type="text" placeholder="Название" :state="nameState" maxlength="100" required/>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import RekonoApi from '@/backend/RekonoApi'
export default {
  name: 'agentModal',
  mixins: [RekonoApi],
  props: ['id'],
  data () {
    return {
      name: null,
      nameState: null,
      invalidName: 'Название агента обязательно'
    }
  },
  methods: {
    check () {
      const valid = this.$refs.agent_form.checkValidity()
      if (!this.validateName(this.name)) {
        this.nameState = false
        this.invalidName = this.name && this.name.length > 0 ? 'Неверное название агента' : 'Название агента обязательно'
      }
      return valid && this.nameState !== false
    },
    confirm (event) {
      event.preventDefault()
      this.nameState = this.validateName(this.name)
      if (this.check()) {
        this.post('/api/agents/', { name: this.name }, this.name, 'Агент успешно создан')
          .then(response => {
            this.$emit('confirm', { id: this.id, success: true, reload: true })
            this.$emit('created', response.token)
          })
          .catch(() => {
            this.$emit('confirm', { id: this.id, success: false, reload: false })
          })
      }
    },
    clean () {
      this.name = null
      this.nameState = null
      this.$emit('clean')
    }
  }
}
</script>
